export type StockQty = number | null | undefined;

export const isOutOfStock = (stockQty: StockQty): stockQty is number =>
  stockQty != null && stockQty <= 0;

export const isBelowThreshold = (
  stockQty: StockQty,
  lowStockThreshold: number | null | undefined,
): stockQty is number =>
  stockQty != null && lowStockThreshold != null && stockQty <= lowStockThreshold;

export type StockLevel = { stockQty: number | null; lowStockThreshold: number | null };

export const NO_CONTROL_LEVEL: StockLevel = { stockQty: null, lowStockThreshold: null };

export const suggestedRestockQty = ({ stockQty, lowStockThreshold }: StockLevel): number | null =>
  isBelowThreshold(stockQty, lowStockThreshold)
    ? Math.max(1, (lowStockThreshold as number) - Math.max(0, stockQty))
    : null;

export const stockStates = ['in-stock', 'low-stock', 'out-of-stock', 'no-control'] as const;

export type StockState = (typeof stockStates)[number];

export function resolveStockState({ stockQty, lowStockThreshold }: StockLevel): StockState {
  if (stockQty === null) {
    return 'no-control';
  }
  if (isOutOfStock(stockQty)) {
    return 'out-of-stock';
  }
  if (isBelowThreshold(stockQty, lowStockThreshold)) {
    return 'low-stock';
  }
  return 'in-stock';
}
